export default __webpack_public_path__ + "img/26.2f85d158.jpg";